// src/api/useSignUp.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../utils/api";

const fetchCreateAssignmentByAdmin = ({ data, agendaId }) => {
  return api.post(`/assignment/${agendaId}/admin`, data);
};

/**
 * 회원가입 요청을 위한 useMutation 훅을 사용하는 커스텀 훅
 */
export const useSubmitAssignmentByAdminQuery = () => {
  return useMutation({
    mutationFn: fetchCreateAssignmentByAdmin,
  });

  // return { mutate, isPending, isError, data, error };
};
